import { styled, Typography, type TypographyProps } from '@ori-ui/mui';

export const Root = styled(Typography)<Pick<TypographyProps, 'component'>>(({ theme }) => ({
  color: theme.palette.grey.A400,
}));
